package org.example.site_web.components.images

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Polyline
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.components.icons.createIcon

@Composable
fun AccTriangleIcon(modifier: Modifier = Modifier.attr("fill","#DD1263")) {
    createIcon(renderStyle = IconRenderStyle.Stroke(0), attrs = modifier.toAttrs()) {
        Polyline {
            points(0 to 24,
                17 to 24,
                17 to 0)
        }
    }
}
